import { render, staticRenderFns } from "./CreateManualCarplateUpdate.vue?vue&type=template&id=ba21eaa4&"
import script from "./CreateManualCarplateUpdate.vue?vue&type=script&lang=js&"
export * from "./CreateManualCarplateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CreateManualCarplateUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports